<template>
  <div class="dat">
    <div class="dat0">
      <img src="~@/assets/mob/images/dat-new/dat00.png" alt="" />
    </div>
    <div class="dat1">
      <img src="~@/assets/mob/images/dat-new/dat01.png" alt="" />
    </div>
    <div class="dat2">
      <img src="~@/assets/mob/images/dat-new/dat02.png" alt="" />
    </div>
    <div class="dat3">
      <img src="~@/assets/mob/images/dat-new/dat03.png" alt="" />
    </div>
    <div class="dat4">
      <img src="~@/assets/mob/images/dat-new/dat04.png" alt="" />
    </div>
    <div class="dat5">
      <img src="~@/assets/mob/images/dat-new/dat05.png" alt="" />
    </div>
    <div class="radius5 dat7" v-if="tableData.length">
      <div class="" style="margin-top: 0.8rem" @click="gotoMore">
        <img src="~@/assets/mob/images/dat-new/dat09.png" alt="" />
      </div>
      <div class="pad20">
        <div class="flex item" @click="gotoItem(val)" v-for="(val, index) in tableData" :key="index">
          <div class="itemLeft">
            <div class="white f26 van-multi-ellipsis--l2">{{ val.listTitle || val.summary }}</div>
            <div class="white f22">{{ val.addTime1 }}</div>
          </div>
          <div class="mar20_l">
            <img style="width: 70px; height: 70px" v-if="val.imgs && val.imgs.length > 0" :src="val.imgs[0] + '?imageView2/1/w/250/h250'" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="dat6">
      <div class="">
        <img src="~@/assets/mob/images/dat-new/dat07.jpg" alt="" style="width: 1.26rem; height: 1.26rem" />
        <img src="~@/assets/mob/images/dat-new/dat08.jpg" alt="" style="width: 1.26rem; height: 1.26rem; margin-left: 0.14rem" />
      </div>
    </div>
    <div class="bg00">
      <img src="~@/assets/mob/images/dat-new/banner.png" alt="" />
    </div>
    <div class="radius5 pad20 dat7" v-if="tableData.length">
      <div class="banner" @click="gotoMore">
        <div class="title1">数说产业互联网</div>
        <div class="title2">查看更多</div>
      </div>
      <div class="flex item" @click="gotoItem(val)" v-for="(val, index) in tableData" :key="index">
        <div class="itemLeft">
          <div class="white f30 fb van-multi-ellipsis--l2">{{ val.listTitle || val.summary }}</div>
          <div class="white">{{ val.addTime1 }}</div>
        </div>
        <div class="mar10_l">
          <img style="width: 70px; height: 70px" v-if="val.imgs && val.imgs.length > 0" :src="val.imgs[0] + '?imageView2/1/w/250/h250'" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      item: {},
      headerH: 0,
      footerH: 0,
      fixedH: 0,
      isF: true,
      showImgs: false,
      index: 1,
      scrollHandle: null,
      tableData: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$store
        .dispatch("api/selContentList", {
          pageNum: 1,
          pageSize: 3,
          concludeImage: "1",
          tagNames: "公众号文章",
        })
        .then((response) => {
          if (response && response.list && response.list.length > 0) {
            this.tableData.push(...response.list);
          }
        });
    },
    gotoItem(item) {
      if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
    gotoMore() {
      window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU2NzgyNjkxNQ==&scene=124#wechat_redirect";
    },
  },
};
</script>
<style>
@import "~@/assets/mob/css/public.scss";
</style>
<style lang="scss">
@import "~@/assets/mob/css/dat-new.scss";
</style>
